// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2730": "b3bca57d","4069": "1f72d271","7656": "98eb53d3",}[chunkId] + ".css"
}